import React from 'react';
import Icon from './Icon';
import { KPICard } from '../../types';

interface StatCardProps extends KPICard {}

const StatCard: React.FC<StatCardProps> = ({ label, value, change, changeType, icon, color }) => {
  const isIncrease = changeType === 'increase';
  const isNeutral = changeType === 'neutral';

  return (
    <div className="card fade-in">
      <div className="flex items-start justify-between">
        <div>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.8rem', fontWeight: 500, marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            {label}
          </p>
          <p style={{ fontSize: '1.75rem', fontWeight: 800, color: 'var(--text-primary)', lineHeight: 1 }}>
            {value}
          </p>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', marginTop: '0.5rem' }}>
            {!isNeutral && (
              <Icon
                name={isIncrease ? 'TrendingUp' : 'TrendingDown'}
                size={14}
                className={isIncrease ? 'text-green-500' : 'text-red-500'}
              />
            )}
            <span style={{
              fontSize: '0.75rem',
              fontWeight: 600,
              color: isNeutral ? 'var(--text-muted)' : isIncrease ? '#10b981' : '#ef4444',
            }}>
              {isNeutral ? 'No change' : `${isIncrease ? '+' : ''}${change}% vs last month`}
            </span>
          </div>
        </div>
        <div style={{
          width: '3rem', height: '3rem', borderRadius: '0.75rem',
          background: `${color}18`, display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>
          <Icon name={icon} size={22} style={{ color }} />
        </div>
      </div>
    </div>
  );
};

export default StatCard;
